import binary from './binary.svg';
import blu from './blu.svg';
import color from './color.svg';
import iraqi from './iraqi.svg';
import kenergy from './kenergy.svg';
import knowbie from './knowbie.svg';
import ryr from './ryr.svg';
import mo from './mo.svg';
import prommoto from './prommoto.svg';
import prommotoLong from './prommoto-long.svg';

export default {
    prommoto,
    ryr,
    blu,
    mo,
    binary,
    knowbie,
    iraqi,
    color,
    kenergy,
    prommotoLong
}
